import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { type B2CMode } from './useB2CModeStore';
import { b2bVersion } from '../../utils/consts.ts';
import { getLocalStorageValue } from '../../utils/local-storage.ts';
import { getJwtModeFromAccessToken } from '../../utils/auth.ts';

type CurrencyState = {
  currency: Currency;
  updateCurrencyByMode: (
    mode: B2CMode,
    userIsRegisteredForTournament?: boolean
  ) => void;
};

const getCurrencyByMode = (
  mode: B2CMode,
  userIsRegisteredForTournament = false
): Currency => {
  // In b2b mode, use currency_id=1 by default.
  // Exception: if JWT payload contains mode=demo, use currency_id=2.
  if (b2bVersion) {
    const accessToken = getLocalStorageValue('userAccessToken')?.accessToken;
    const jwtMode = getJwtModeFromAccessToken(accessToken);
    const id = jwtMode === 'demo' ? 2 : 1;
    return {
      type: null,
      id,
    };
  }

  switch (mode) {
    case 'demo':
      return {
        type: null,
        id: 1,
      };
    case 'blockchain':
      return {
        type: 'blockchain',
        id: 99,
      };
    case 'tournament':
      return userIsRegisteredForTournament
        ? {
            type: 'tournament',
            id: 2,
          }
        : {
            type: 'cr',
            id: 100,
          };
    default:
      throw new Error(`Unknown mode: ${mode}`);
  }
};

export const useCurrencyStore = create<CurrencyState>()(
  immer((set) => ({
    currency: {
      type: null,
      id: 1,
    },
    updateCurrencyByMode: (mode, userIsRegisteredForTournament) => {
      set((state) => {
        state.currency = getCurrencyByMode(mode, userIsRegisteredForTournament);
      });
    },
  }))
);
